import { Alert, Card } from "react-bootstrap";
import i18n from "i18next";
import { ResolvedDocumentAttachment } from "../../services/document/DocumentAttachmentService";
import { PapyrusDocumentRepresentation } from "../../services/document/DocumentModels";

type PdfViewerProps = {
    representation: PapyrusDocumentRepresentation;
    resolvedAttachment?: ResolvedDocumentAttachment;
};

export default function PdfViewer({ representation, resolvedAttachment }: PdfViewerProps) {
    const pdfUrl = resolvedAttachment?.sourceUrl ?? resolvedAttachment?.objectUrl;

    return (
        <Card>
            <Card.Body>
                <Card.Title>{i18n.t("viewer.pdf")}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                    {representation.contentType}
                </Card.Subtitle>
                {pdfUrl ? (
                    <iframe
                        title={representation.id}
                        src={pdfUrl}
                        style={{ width: "100%", minHeight: "80vh", border: 0 }}
                    />
                ) : (
                    <Alert variant="warning">{i18n.t("viewer.nopdf")}</Alert>
                )}
            </Card.Body>
        </Card>
    );
}
